module.exports = __webpack_public_path__ + "static/img/Cardfooter07.7debe29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cardfooter07.png
// module id = csNG
// module chunks = 1